import { Box, Typography } from '@mui/material';

import { diploma, headphonesLined, phone } from '@/images';
import { selectUserRegion, useAppSelector } from '@/store';

const HighlightCard = ({
  title,
  description,
  imgSrc,
}: {
  title: string;
  description: string;
  imgSrc: string;
}) => (
  <Box>
    <Box
      component="img"
      src={imgSrc}
      sx={{
        width: 128,
        height: 128,
        display: 'block',
        m: { md: 0, xs: '0 auto' },
      }}
    />
    <Typography variant="h2" sx={{ mb: 2, mt: 3 }}>
      {title}
    </Typography>
    <Typography variant="body2">{description}</Typography>
  </Box>
);

export const AppHighlights = () => {
  const region = useAppSelector(selectUserRegion);
  return (
    <Box
      sx={{
        padding: 1,
        display: 'grid',
        gridTemplateColumns: { md: '1fr 1fr 1fr' },
        gap: 4,
        my: { md: 12.5, xs: 2 },
      }}>
      <HighlightCard
        imgSrc={diploma}
        title="Learn from the Experts"
        description="We have the best guests in conversation with knowledgeable hosts. Learn from industry experts, best-selling authors, and business leaders from top companies across the globe!"
      />
      <HighlightCard
        imgSrc={headphonesLined}
        title="Hear the Difference"
        description="We pride ourselves on high-quality production. From in-depth discussions, to narrative-driven Special Features, and our true-crime style investigations, it's easy to hear the LumiQ difference."
      />
      <HighlightCard
        imgSrc={phone}
        title={`Earn ${region === 'USA' ? 'CPE' : 'CPD'} On the Go`}
        description="Use the LumiQ mobile app to listen and learn wherever and whenever you want. Download episodes to listen offline, perfect for commuting to the office or on flights to conferences."
      />
    </Box>
  );
};
